module.exports = __webpack_public_path__ + "img/laptop_phone_shot.3303f142.webp";